import { useMutation } from "@tanstack/react-query";
import type { CreateBetaFeedbackBody } from "@shared/validation/betaFeedback.schema";
import { apiClient, ApiError } from "./client";

/**
 * Public, unauthenticated. Nothing to invalidate on success — feedback is
 * write-only from the app's side. Two callers: the landing page's form (name,
 * email, rating, note) and the signed-in help menu's "Send feedback" (note,
 * rating and the page path; no name or email).
 */
export function useSubmitBetaFeedback() {
  return useMutation<{ received: boolean }, ApiError, CreateBetaFeedbackBody>({
    mutationFn: (vars) =>
      apiClient<{ received: boolean }>("/api/beta-feedback", {
        method: "POST",
        body: JSON.stringify(vars),
      }),
  });
}
